
/* ********************************
SVG Animations 
********************************* */
anime({
	targets: '.default-wave path',
	d: [
		//2
		{
			value: 'm0 40.865s262.16 77.245 512.76 56.6c269.22-22.179 580.43-64.998 845.31-30.292 264.88 34.706 563.93 69.827 563.93 69.827l-1 37-1920 1z'
		},
		//3
		{  
			value: 'm0 62.865s233.55 77.85 512.76 28.6c266.03-46.926 580.43-42.998 845.31-8.292 264.88 34.706 563.93 41.827 563.93 41.827l-1 49-1920 1z' 
		},
		//4
		{  
			value: 'm0 84.865s195.41 50.747 512.76-9.3997c265.41-50.304 554.55-17.17 845.31 25.708 290.76 42.878 563.93 9.8271 563.93 9.8271l-1 63-1920 1z' 
		},
		//5
		{  
			value: 'm0 104.86s195.41 12.747 512.76-47.4c265.41-50.304 555.92 35.348 845.31 53.708 289.4 18.36 563.93-18.173 563.93-18.173l-1 81-1920 1z' 
		},
		//6
		{  
			value: 'm0 112.86s190.66-42.235 512.76-66.297c272.22-20.336 580.43 90.472 845.31 74.778 264.88-15.694 563.93-38.346 563.93-38.346l-1 91-1920 1z' 
		},
		//7
		{  
			value: 'm0 102.86s213.12-65.912 512.76-63.4c270.12 2.2647 540.93 126.99 845.31 67.708 304.38-59.283 563.93-30.173 563.93-30.173l-1 97-1920 1z' 
		},
		//8
		{  
			value: 'm0 80.865s220.54-87.861 512.76-33.4c255.34 47.588 472.82 108.99 845.31 49.708 372.49-59.283 563.93-24.173 563.93-24.173l-1 101-1920 1z' 
		},
		//9
		{  
			value: 'm0 42.865s168.56-56.624 511.39 27.238c290.72 71.115 494.62 76.818 846.67 12.086 352.05-64.732 563.93 12.811 563.93 12.811l-1 79-1920 1z' 
		},
		//10
		{  
			value: 'm0 20.865s216.24 9.3438 511.39 63.238c294.43 53.761 493.26 17.402 846.67-11.914 353.42-29.316 563.93 38.811 563.93 38.811l-1 63-1920 1z' 
		},
		//11
		{  
			value: 'm0 7.2431s213.35 61.45 511.39 95.93c299.88 34.691 493.26-34.36 846.67-37.794 353.42-3.4348 563.93 55.622 563.93 55.622l-1 53-1920 1z' 
		},
		//1
		{  
			value: 'm0 0s258.07 109.94 514.12 107c270.12-3.0979 587.97-50.014 844.68-50.724 256.7-0.71051 563.21 74.724 563.21 74.724l-1 43-1920 1z' 
		}
	],
	loop: true,
	easing: 'linear',
	duration: '9000',
});


anime({
	targets: '.feat-offer__wave svg path, .map-ov__wave svg path, .big-wave path',
	d: [
		//2
		{
			value: 'm-1 3039h1921v-370.55s-251.37 57.708-561.45 88.827c-280 28.1-551.01-61.043-784.1-80.626-370.79-31.149-575.45 79.767-575.45 79.767z'
		},
		//3
		{  
			value: 'm-1 3039h1921v-355.25s-130.98-68.268-564 51.855c-274.89 76.255-551.17 4.5189-781.55-36.004-409.03-71.946-575.45 23.671-575.45 23.671z' 
		},
		//4
		{  
			value: 'm-1 3039h1921v-329.76s-248.37-101.02-560.17 2.1335c-276.49 91.474-558.94 68.53-786.65 14.992-409.03-96.169-574.18-36.249-574.18-36.249z' 
		},
		//5
		{  
			value: 'm-1 3039h1921v-302.98s-389.88-103.57-560.17-47.588c-276.66 90.956-699.56 105.69-785.38 64.713-174.55-83.341-575.45-84.695-575.45-84.695z' 
		},
		//6
		{  
			value: 'm-1 3039h1921v-286.98s-395.91-75.651-562.72-80.161c-126.06-3.4084-598.55 144.92-782.83 96.586-145.64-38.202-575.45-87.994-575.45-87.994z' 
		},
		//7
		{  
			value: 'm-1 3039h1921v-282.58s-400.53-43.997-565.27-70.536c-108.21-17.432-568.48 53.98-779 84.012-163.44 23.316-576.73-69.046-576.73-69.046z' 
		},
        //8
		{  
			value: 'm-1 3039h1921v-297.88s-398.54-8.8479-562.72-38.663c-187.26-34.006-579.59-33.576-781.55 33.016-275.64 90.885-576.73-0.2012-576.73-0.2012z' 
		},
        //9
		{
            value: 'm-1 3039h1921v-323.38s-399.62 53.022-561.45 12.333c-180.88-45.48-591.99-82.452-782.83-34.554-236.44 59.344-576.73 63.018-576.73 63.018z'   
		},
        //10
		{  
			value: 'm-1 3039h1921v-370.55s-283.91 87.968-561.45 81.177c-181.09-4.431-591.06-104.13-784.1-72.801-203.13 32.962-575.45 79.592-575.45 79.592z' 
		},
		//1
		{  
			value: 'm-1 3039h1921v-393.5s-261.28 110.92-572.92 110.5c-258.33-0.3451-536.16-86.604-770.08-87-326.16-0.5518-578 110-578 110z' 
		}
	],
	loop: true,
	easing: 'linear',
	duration: '6000',
});

/* 
var dtl = anime({
	targets: '.intro-content-home__blue-wave path',
	d: [
		//2
		{
			value: 'm406 577c-50.323-301.99-219.26-319.05-286.2-372.57-66.944-53.526-58.456-117.23 16.355-143.57 74.812-26.348 342.09-81.031 371.85-40.851 112.71 152.18-102 557-102 557z'
		},
		//1
		{  
			value: 'm406 577c-50.323-301.99-300.87-323.95-367.82-377.47-66.944-53.526-37.237-135.18 37.574-161.53 74.811-26.348 402.48-58.18 432.24-18 112.71 152.18-102 557-102 557z' 
		}
	],
	loop: true,
	easing: 'easeInOutQuad',
	duration: '15000',
	complete: function(anim){
		setTimeout(function(){
			anim.play();
			console.log('play');
		},3000)
	}
}); */


/* anime({
	targets: '.amenities-wave path',
	d: [
		//2
		{
			value: 'm0 40.865s262.16 77.245 512.76 56.6c269.22-22.179 580.43-64.998 845.31-30.292 264.88 34.706 563.93 69.827 563.93 69.827l-1 37-1920 1z'
		},
		//3
		{  
			value: 'm0 62.865s233.55 77.85 512.76 28.6c266.03-46.926 580.43-42.998 845.31-8.292 264.88 34.706 563.93 41.827 563.93 41.827l-1 49-1920 1z' 
		},
		//4
		{  
			value: 'm0 84.865s195.41 50.747 512.76-9.3997c265.41-50.304 554.55-17.17 845.31 25.708 290.76 42.878 563.93 9.8271 563.93 9.8271l-1 63-1920 1z' 
		},
		//5
		{  
			value: 'm0 104.86s195.41 12.747 512.76-47.4c265.41-50.304 555.92 35.348 845.31 53.708 289.4 18.36 563.93-18.173 563.93-18.173l-1 81-1920 1z' 
		},
		//6
		{  
			value: 'm0 112.86s190.66-42.235 512.76-66.297c272.22-20.336 580.43 90.472 845.31 74.778 264.88-15.694 563.93-38.346 563.93-38.346l-1 91-1920 1z' 
		},
		//7
		{  
			value: 'm0 102.86s213.12-65.912 512.76-63.4c270.12 2.2647 540.93 126.99 845.31 67.708 304.38-59.283 563.93-30.173 563.93-30.173l-1 97-1920 1z' 
		},
		//8
		{  
			value: 'm0 80.865s220.54-87.861 512.76-33.4c255.34 47.588 472.82 108.99 845.31 49.708 372.49-59.283 563.93-24.173 563.93-24.173l-1 101-1920 1z' 
		},
		//9
		{  
			value: 'm0 42.865s168.56-56.624 511.39 27.238c290.72 71.115 494.62 76.818 846.67 12.086 352.05-64.732 563.93 12.811 563.93 12.811l-1 79-1920 1z' 
		},
		//10
		{  
			value: 'm0 20.865s216.24 9.3438 511.39 63.238c294.43 53.761 493.26 17.402 846.67-11.914 353.42-29.316 563.93 38.811 563.93 38.811l-1 63-1920 1z' 
		},
		//11
		{  
			value: 'm0 7.2431s213.35 61.45 511.39 95.93c299.88 34.691 493.26-34.36 846.67-37.794 353.42-3.4348 563.93 55.622 563.93 55.622l-1 53-1920 1z' 
		},
		//1
		{  
			value: 'm0 0s258.07 109.94 514.12 107c270.12-3.0979 587.97-50.014 844.68-50.724 256.7-0.71051 563.21 74.724 563.21 74.724l-1 43-1920 1z' 
		}
	],
	loop: true,
	easing: 'linear',
	duration: '24000',
}); */

/* ********************************
Parallax Init 
********************************* */

if( document.querySelector('.rellax') ){
	var rellax = new Rellax('.rellax');
}
